export const SET_DETAILS = 'SET_DETAILS';
export const STOCK_LEDGER = 'STOCK_LEDGER';
export const SET_SKU_DETAILS = 'SET_SKU_DETAILS';
export const SET_META_DATA = 'SET_META_DATA';
export const CUSTOMER_DETAILS = 'CUSTOMER_DETAILS';
export const LEDGER_GROUP_DETAILS = 'LEDGER_GROUP_DETAILS';
export const JOURNAL_VOUCHER_DETAILS = 'JOURNAL_VOUCHER_DETAILS';
export const TAG_DETAILS = 'TAG_DETAILS';
